<!-- <div class="header-background">
    <img class="goldbharat-icon" routerLink="/mobile/mobileview" src="../../../assets/GoldBharatone.png" alt="">
    <div *ngIf="isLogin" routerLink="/mobile/notifications"><img  class="notification-icon" src="../../../assets/Vector.png" alt=""><span class="nottification">{{notLength}}</span></div>
    <button *ngIf="!isLogin" class="loginbotn" routerLink="/login">
        Login
      </button>
</div> -->

<div class="header-background">
  <div class="logo-container">
    <!-- Gold Emirates Image (Always visible for UI component) -->
    <img 
      class="goldbharat-icon" 
      [routerLink]="'/mobile/ui'"
      [src]="logoSrc" 
      alt="Gold Emirates Logo"
    >

    <!-- Dubai Arabic Image (Only visible for UI component) -->
    <img 
      *ngIf="showDubaiArabic"
      class="goldbharat-icon" 
      [routerLink]="'/mobile/ui'"
      [src]="dubaiSrc" 
      alt="Dubai Arabic Logo"
    >
  </div>

  <!-- Notifications Section -->
  <!-- <div *ngIf="isLogin" routerLink="/mobile/notifications">
    <img class="notification-icon" src="../../../assets/images/blackvec.png" alt="">
    <span class="notification">{{ notLength }}</span>
  </div> -->
  <div *ngIf="isLogin" routerLink="/mobile/notifications">
    <img
        class="notification-icon"
        src="../../../assets/images/blackvec.png"
        alt=""
    >

    <span class="notification">{{ notLength }}</span>
</div>

  <!-- Login Button (Only visible for mobileview component) -->
  <button *ngIf="!isLogin && showLoginButton" class="loginbotn" routerLink="/login">
    Login
  </button>
</div>






